/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { errorResponseSchema } from "../errorResponseSchema.ts";
import { messageResponseSchema } from "../messageResponseSchema.ts";
import { z } from "zod";

export const deleteMemberFromOrganizationPathParamsSchema = z.object({
      "id": z.string().describe("ID unique de l'organisation.")
      })

export const deleteMemberFromOrganizationQueryParamsSchema = z.object({
      "memberId": z.string().describe("ID unique du membre à supprimer.")
      })

export const deleteMemberFromOrganizationHeaderParamsSchema = z.object({
      "X-Client-Id": z.string().describe("ID du client/application pour lequel récupérer les informations utilisateur.")
      })

/**
 * @description Réponse contenant un message simple
 */
export const deleteMemberFromOrganization200Schema = z.lazy(() => messageResponseSchema).describe("Réponse contenant un message simple")

/**
 * @description Réponse d\'erreur standard
 */
export const deleteMemberFromOrganization500Schema = z.lazy(() => errorResponseSchema).describe("Réponse d'erreur avec message et code de statut")

export const deleteMemberFromOrganizationMutationResponseSchema = z.lazy(() => deleteMemberFromOrganization200Schema)